import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ExchangeService {
  // Change this variable if you want yo hide or show the exchange sections and balances (in dashboard and wallet service)
  public showExchange = true;
  whiteListShowHide$: Subject<Boolean> = new Subject<Boolean>();
  walletExchangeUrl: any = environment.apiUrl + 'wallet/';
  exchangeUrl: any = environment.apiUrl + 'exchange/';
  userUrl: any = environment.apiUrl + 'user/';

  constructor(private http: HttpClient,
    private userService: UserService) {
  }

  /**
   *  Method to get the depth chart data
   * @param data Receive size and symbol
   */
  getDepthData(data) {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'depth?size=' + data.size + '&symbol=' + data.symbol, { headers });
  }

  /**
   *  Method to get fee status
   */
  getFee() {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'fee', { headers });
  }


  /**
   *  Method to cancel the order
   * @param data Receive the order id
   */
  cancelOrder(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'cancel-order?id=' + data.orderId, { headers });
  }


  /**
   *  Method to get the current market data (Prices, changes and more)
   */
  getMarketData() {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'market', { headers });

  }

  /**
   *  Method to get the user orders
   *  @param data Receive data with  this:
   *  base: base coin, hideCancelled: hide cancel order, page: page number, quote: quote coin,
   *  side: Buy or Sell, size: page size, transactionStatus: OPEN or COMPLETED
   */
  getUserOrders(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.exchangeUrl + 'user-order', data, { headers });
  }

  /**
   *  Method to get the user trades
   *  @param data Receive data with  this:
   *  base: base coin, page: page number, quote: quote coin, side: Buy or Sell, size: page size
   */
  getUserTrades(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.exchangeUrl + 'trades', data, { headers });
  }

  /**
   *  Method to get the order book data
   *  @param data Receive the symbol (base_quote)
   */
  getOrderBook(data) {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'order-book?symbol=' + data.symbol, { headers });
  }

  /**
   *  Method to place the order
   *  @param data Receive data with this:
   *  percentageTrailingStop, price, quantity, quoteOrderQty, side, stopPrice, symbol, timeInForce, trailingStop, type
   *  Data changes in each order type.
   */
  placeOrder(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.exchangeUrl + 'order', data, { headers });
  }

  /**
   *  Method to get the trade history
   *  @param data Receive the symbol (base_quote)
   */
  getTradeHistory(data) {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'transactions?symbol=' + data.symbol, { headers });
  }

  /**
   *  Method to get which is the market coin
   *  @param data Receive both coins shortName
   */
  getMarketCoin(data) {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'get-market-coin?firstCoin=' + data.firstCoin + '&secondCoin=' + data.secondCoin, { headers });
  }



  /**
   *  Method to get the exchange balances
   */
  getExchangeBalance(q = '') {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    let query
    if (q!=='') {
      query = q + '&preferredCurrency=' + (loggedData?.preferredCurrency?.shortName || 'USD')
    }else{
      
      query = '?fiat=true&preferredCurrency=' + (loggedData?.preferredCurrency?.shortName || 'USD')
    }
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'get-balances' + query, { headers });
  }

   /**
   *  Method to get the exchange balances
   */
   getExchangeBalanceUSD(q = '') {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    let query = '?preferredCurrency=' + ('USD')
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'get-balances' + query, { headers });
  }

  /**
   *  Method to get the exchange balances
   */
  getExchangeCoinBalance(asset, currency) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    let query = '&preferredCurrency=' + (currency || loggedData?.preferredCurrency?.shortName || 'USD')

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'get-balance?asset=' + asset + query, { headers });
  }


  /**
   *  Method to get the exchange balances
   */
  addExchangeBalance(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.exchangeUrl + 'add-balance', data, { headers });
  }

  /**
   *  Method to get the exchange balances
   */
  deductExchangeBalance(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.exchangeUrl + 'deduct-balance', data, { headers });
  }

  /**
   *  Method to get the approximate amount to quick exchange.
   *  @param data Receive quantity or quoteQuantity, side, marketCoin
   */
  quickAmount(data) {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.exchangeUrl + 'quantity', data, { headers });
  }


  /**
   *  Method to get the approximate amount to quick exchange.
   *  @param data Receive quantity or quoteQuantity, side, marketCoin
   */
  quickObsicashAmount(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token)
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.exchangeUrl + 'calculate-quantity', data, { headers });
  }

  /**
   *  Method to get the exchange status: Able or disable for the user
   */
  getExchangeStatus() {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.userUrl + 'get-exchange-status', { headers });
  }

  /**
   *  Method to get the coins available for exchange
   *  @param data Receive coinShortName to consult.
   */
  getAvailableCoins(data) {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.walletExchangeUrl + 'get-available-coins?coinShortName=' + data.coinShortName, { headers });
  }

  /**
   *  Method to move fund Wallet to Exhange and Exchange to Wallet
   *  @param data Receive amount to move, asset and moveType (WALLET_TO_EXCHANGE or EXCHANGE_TO_WALLET)
   */
  moveFunds(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.walletExchangeUrl + 'move-fund', data, { headers });
  }

  getObsicashOrders(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.exchangeUrl + 'trades', data, { headers });
  }
  /**
   * this method is new generate deposit address here the data should have asset and network
   * */
  generateCoinDepositAddress(asset, network) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.exchangeUrl + 'address?asset=' + asset + '&network=' + network, { headers });

  }

  /**
  * this method is  generate withdrawl request 
  * */

  getWithdrawalRequest(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.exchangeUrl + 'generate-withdraw-request', data, { headers });

  }
}
